<template>
  <v-row>
    <v-col cols="6" class="px-5">
      <logo type="veci" height="40px" />
    </v-col>
    <v-col cols="6" class="d-flex justify-end px-5">
      <img  alt="Foto header"  style="height: 40px" :src="this.configurations.data.logo_url" />
    </v-col>
    <v-col cols="12" style="color: white; position: relative;">
      <img alt="Foto header" width="100%" :src="this.configurations.data.banner_url" />
      <div v-if="false" class="image-text">
        <h2
          style="font-weight: bolder; line-height: initial; margin-bottom: 15px;"
        >
          Recibe los pagos <br />
          de tus pedidos
        </h2>
        <h4 style="font-weight: 300;">
          Fácil, rápido y seguro. <br />
        </h4>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import Logo from "./Logo";

export default {
  components: { Logo },
  data() {
    return {
      mode: process.env.VUE_APP_MODE
    };
  },
  props: {
    configurations: { type: Object }
  },
};
</script>
<style lang="sass" scoped>
.image-text
  max-width: 40%
  font-family: 'Quicksand'
  font-size: 3vw
  position: absolute
  top: 50%
  left: 10%
  transform: translate(0%, -50%)
</style>
